import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { DocumentActions } from 'actions';
import { getMomentFromDateBackend } from 'utils/dates';
import { Download, SeparatorLine } from 'components/SvgIcons';
import { CarouselFullModal } from 'components/carousels';

import './WidgetActivitiesCarouselStyles.scss';

const mapDispatchToProps = (dispatch) => {
    return {
        downloadDocument: bindActionCreators(DocumentActions, dispatch).downloadDocument,
    };
};

@connect(null, mapDispatchToProps)
class WidgetActivitiesCarousel extends PureComponent {
    state = {};

    handleDownloadDocument = (event) => {
        const { imageSelected } = this.props;
        const { downloadDocument } = this.props;

        if (!imageSelected) return;

        downloadDocument(imageSelected);
    };

    renderContentLeft = () => {
        const { imageSelected } = this.props;

        if (!imageSelected) return;

        return (
            <div className="fm-widget-activities-carousel-header-left">{imageSelected.file}</div>
        );
    };

    renderContentCenter = () => {
        const { imageSelected } = this.props;

        if (!imageSelected) return;

        const date = imageSelected.fmodificado
            ? imageSelected.fmodificado.split(' ')[0]
            : imageSelected.fcreado.split(' ')[0];

        const dateMoment = getMomentFromDateBackend(date, 'DD/MM/YYYY');

        return (
            <div className="fm-widget-activities-carousel-header-center">
                {dateMoment.format('dddd D MMM YYYY')}
            </div>
        );
    };

    renderContentRight = () => {
        return (
            <Fragment>
                <div className="fm-full-modal-blank__icon" onClick={this.handleDownloadDocument}>
                    <Download color="$fmWhite" />
                </div>
                <div className="fm-full-modal-blank__divider">
                    <SeparatorLine />
                </div>
            </Fragment>
        );
    };

    render() {
        const { isModalOpen, imageSelected, images, onRequestClose, updateImageSelected } =
            this.props;

        //carousel is expecting the parameter url to print the images
        const imagesForCarousel = images.map((image, index) => {
            return {
                ...image,
                url: image.BigUrl,
            };
        });

        return (
            <CarouselFullModal
                isOpen={isModalOpen}
                withCloseIcon={true}
                onRequestClose={onRequestClose}
                updateImageSelected={updateImageSelected}
                contentLeft={this.renderContentLeft}
                contentCenter={this.renderContentCenter}
                contentRight={this.renderContentRight}
                images={imagesForCarousel}
                imageSelected={imageSelected}
            />
        );
    }
}

export default WidgetActivitiesCarousel;
